module.exports = __webpack_public_path__ + "img/avatar_2.88130dfe.png";